module.exports = __webpack_public_path__ + "static/media/Circlelogoapplied-02-12-2025.c4b28c86.png";